import { usePage } from "@inertiajs/react";
import classNames from "classnames";

import Button from "/components/Button";
import Select from "/components/Select";
import MultiSelect from "/components/MultiSelect";
import DropZone from "/components/DropZone";
import TextField from "/components/TextField";
import TextArea from "/components/TextArea";

import longArrowUpIcon from "/assets/long-arrow-up.svg";
import longArrowDownIcon from "/assets/long-arrow-down.svg";
import videoIcon from "/assets/video.svg";

export default function LayoutForm({
  useStore,
  onRemove,
  onOrderUp,
  onOrderDown,
}) {
  const {
    layout_type_codename,
    image,
    video_url,
    lottie_json,
    thumbnail_url,
    play_mode,
    layout_content_type_ids,
    description_ru,
    description_en,
    hidden,
    setImage,
    setVideoUrl,
    setLottieJson,
    setPlayMode,
    setLayoutContentTypeIds,
    setDescriptionRu,
    setDescriptionEn,
    setHidden,
  } = useStore();

  const {
    layout_content_type_options,
    layout_play_mode_options,
  } = usePage().props;

  return (
    <div className={classNames("layout-form", { "layout-form--hidden": hidden })}>
      <div className="actions-bar actions-bar--nested">
        <div></div>
        <div>
          <div className="actions-bar__order-buttons">
            <Button onClick={onOrderUp} className="btn--icon"><img src={longArrowUpIcon} /></Button>
            <Button onClick={onOrderDown} className="btn--icon"><img src={longArrowDownIcon} /></Button>
          </div>
          <Button className="lnk lnk--blue" onClick={() => setHidden(!hidden)}>
            {hidden ? "Отобразить" : "Скрыть"}
          </Button>
          <Button onClick={onRemove} className="lnk lnk--red">Удалить</Button>
        </div>
      </div>

      <div className="layout-form__inputs">
        {layout_type_codename === "image" && (
          <DropZone
            label="Загрузка изображения"
            className="layout-form__image-dropzone"
            value={image}
            onChange={setImage}
          />
        )}

        {layout_type_codename === "video" && (
          <div className="inpt-grp">
            <label className="lbl">Привью</label>
            {thumbnail_url?.length ? (
              <div className="layout-form__video-preview">
                <img src={thumbnail_url} />
              </div>
            ) : (
              <div className="layout-form__video-preview-placeholder">
                <img src={videoIcon} />
              </div>
            )}
          </div>
        )}

        <div className="layout-form__text-inputs frm frm--small">
          {layout_type_codename === "lottie" && (
            <TextArea
              label="Lottie JSON"
              placeholder="Вставьте Lottie JSON"
              value={lottie_json}
              onChange={setLottieJson}
            />
          )}

          {layout_type_codename === "video" && (
            <div className="inpt-line">
              <TextField
                label="Ссылка на видео"
                placeholder="Vimeo или Kinescope"
                value={video_url}
                onChange={setVideoUrl}
              />

              <Select
                label="Режим проигрывания"
                options={layout_play_mode_options}
                value={play_mode}
                defaultValue={"loop"}
                onChange={setPlayMode}
              />
            </div>
          )}

          <div className="inpt-line">
            <MultiSelect
              label="Содержимое макета"
              locale="ru"
              options={layout_content_type_options}
              value={layout_content_type_ids}
              onChange={setLayoutContentTypeIds}
              placeholder="Выберите из списка"
            />
            <MultiSelect
              label="Content type"
              locale="en"
              options={layout_content_type_options}
              value={layout_content_type_ids}
              onChange={setLayoutContentTypeIds}
              placeholder="Select from the Russian dropdown list"
              disabled
            />
          </div>

          <div className="inpt-line">
            <TextArea
              label="Описание"
              placeholder="Введите краткое описание, чтобы оно занимало 2-3 предложения"
              value={description_ru}
              onChange={setDescriptionRu}
            />

            <TextArea
              label="Description"
              placeholder="Please provide a brief description that is 2-3 sentences long"
              value={description_en}
              onChange={setDescriptionEn}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
